import { ENV } from '@/constants';
import { exploreSchemaItemList } from '../exploreSchema';

export const schemaObject_PhotoToSketch = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/photo-to-sketch',
			name: 'Image to Sketch Converter — AI Sketch Generator | Lift',
			description:
				"Transform any photo into a pencil sketch with Lift's AI converter. Upload your image and get professional hand-drawn effect instantly. No watermark. Try now!",
			url: 'https://liftapp.ai/photo-to-sketch',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/photo-to-sketch#product' },
				{ '@id': 'https://liftapp.ai/photo-to-sketch#howto' },
				{ '@id': 'https://liftapp.ai/photo-to-sketch#benefits' },
				{ '@id': 'https://liftapp.ai/photo-to-sketch#faq' },
				{ '@id': 'https://liftapp.ai/photo-to-sketch#why-lift' },
				{ '@id': 'https://liftapp.ai/photo-to-sketch#explore-tools' },
				{ '@id': 'https://liftapp.ai/photo-to-sketch#all-in-one' },
			],
		},
		// product
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/photo-to-sketch#product',
			name: 'Image to Sketch Converter',
			description:
				"Turn your photos into beautiful pencil sketches instantly with Lift's AI sketch converter. Create stunning hand-drawn effects in seconds — no artistic skills required, just upload and transform.",
			url: 'https://liftapp.ai/photo-to-sketch',
			fileFormat: ['image/jpeg', 'image/png', 'image/webp'],
			memoryRequirements: 'Max file size: 20MB',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: '4.8',
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		// howto
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/photo-to-sketch#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Upload your photos',
					text: "Choose a photo from your device or take one using Lift's app",
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'AI applies the sketch effect',
					text: 'Instantly convert your photo into hand-drawn effect',
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Customize adjustments',
					text: 'Fine-tune your image with easy-to-use editing tools',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Download and use',
					text: 'Download your image or publish it straight to your social feeds',
				},
			],
		},
		// benefit
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/photo-to-sketch#benefits',
			name: 'Who can benefit from AI Photo to Sketch Converter?',
			description:
				"Lift's AI Photo to Sketch Converter is useful for artists, designers, social media creators, students, educators, content marketers, and anyone looking for creative visual effects.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Perfect for artists and designers exploring hand-drawn aesthetics without manual sketching',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Social media creators stand out with artistic, vintage-inspired posts',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Students and educators can visualize concepts with clean, sketch-style imagery',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Content marketers create eye-catching visuals that feel handcrafted and authentic',
				},
				{
					'@type': 'ListItem',
					position: 5,
					name: 'Quick, creative, and premium-quality — ideal for personal fun or online branding',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/benefits.3da6de53.webp',
				name: 'Photo To Pencil Sketch online',
				description: 'Photo To Pencil Sketch online',
			},
		},

		// faq
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/photo-to-sketch#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is Lift AI Photo to Sketch Converter?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift AI Photo to Sketch Converter is an online tool that transforms your photos into realistic pencil illustrations — perfect for prints, gifts, social media, or creative projects.',
					},
				},
				{
					'@type': 'Question',
					name: 'How does Lift AI Photo to Sketch Converter work?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Our AI analyzes your photo's edges, shadows, and textures, then recreates it with hand-drawn pencil strokes, crosshatching, and shading. The result looks authentically sketched — no manual drawing or editing required.",
					},
				},
				{
					'@type': 'Question',
					name: 'Can I convert any photo into AI Sketch?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Yes. Lift works with portraits, landscapes, pets, objects, and any image type. You don't need professional drawing skills or costly software — with a online photo-to-sketch tool, you can quickly transform any portrait into a stunning, lifelike illustration.",
					},
				},
				{
					'@type': 'Question',
					name: 'Can I download the results without a watermark?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Absolutely. All images generated or edited in Lift can be exported without watermark when you're on the Pro plan. Download them in high-res PNG or JPG — ready for social media, print, framing, or gifts.",
					},
				},
			],
		},

		// why lift
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/photo-to-sketch#why-lift',
			name: "Why Lift's AI Photo to Sketch Converter stands out",
			description:
				"Lift's AI Photo to Sketch Converter combines professional-grade AI, ease of use, and affordability — making it a trusted choice for millions of users worldwide.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'High-quality results',
					description:
						'AI-powered technology delivers professional-grade visuals every time',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Intelligent rendering',
					description:
						'AI tailors the effect to the scene and subject for optimal results',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description: 'Available on iOS, Android, and Web for seamless access',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly designers with an affordable and intuitive tool',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/whyUse.ae83a89c.webp',
				name: 'Photo To Sketch Converter',
				description: 'Photo To Sketch Converter',
			},
		},
		// explore
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/photo-to-sketch#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},

		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/photo-to-sketch#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
				},
			],
		},

		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Image to Sketch Converter',
					item: 'https://liftapp.ai/photo-to-sketch',
				},
			],
		},
	],
};
